import {
  CanvasElementType,
  CanvasLayer,
  CanvasObjectPosition,
  CanvasObjectSize,
  CanvasObjectStyles,
} from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

const canvasEmojiStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
};

const canvasEmojiDefaultSize: CanvasObjectSize = {
  width: 45,
  height: 45,
};

export function getCanvasEmojiModel(data: { position: CanvasObjectPosition; emojiName: string; emojiCode: string }) {
  return {
    type: CanvasElementType.Emoji,
    layer: CanvasLayer.EmojiNodes,
    position: data.position,
    size: canvasEmojiDefaultSize,
    styles: canvasEmojiStylesDefaultConstant,
    objectProperties: {
      ...defaultCanvasObjectProperties,
      resizable: false,
      rotatable: false,
    },
    typeSettings: {
      emojiName: data.emojiName,
      emojiCode: data.emojiCode,
    },
  };
}

export type CanvasEmojiModel = VisualizationCanvasElementStoreModel<CanvasElementType.Emoji>;
